import React, { createContext, useCallback, useContext, useState } from 'react';

import type { AgentId } from '~/features/ask-anything/chat-bot-panel/agentIds';

interface AgentContextValue {
  selectedAgent: AgentId;
  selectAgent: (id: AgentId) => void;
  availableAgents: Array<{
    id: string;
    label: string;
    description?: string;
    icon?: string;
  }>;
}

const AgentContext = createContext<AgentContextValue | undefined>(undefined);

interface AgentProviderProps {
  children: React.ReactNode;
  onResetAgent?: () => void;
}

export const AgentProvider = ({
  children,
  onResetAgent,
}: AgentProviderProps) => {
  const [selectedAgent, setSelectedAgent] = useState<AgentId>(null);

  const selectAgent = useCallback(
    (id: AgentId) => {
      setSelectedAgent(id);
      if (id === null && onResetAgent) {
        onResetAgent();
      }
    },
    [onResetAgent],
  );

  const availableAgents: Array<{
    id: string;
    label: string;
    description?: string;
    icon?: string;
  }> = [];

  return (
    <AgentContext.Provider
      value={{
        selectedAgent,
        selectAgent,
        availableAgents,
      }}
    >
      {children}
    </AgentContext.Provider>
  );
};

export const useAgent = (): AgentContextValue | undefined => {
  const context = useContext(AgentContext);
  return context;
};
